// extracted by mini-css-extract-plugin
export default {"contentContainer":"PrivateLayout_contentContainer__yLv5Z"};